/**
 * Monotonic session generation — bumped on logout so in-flight refresh cannot resurrect auth.
 * Persisted for cross-tab coordination.
 */

const STORAGE_KEY = 'codemerlin-session-epoch';

let memoryEpoch = 0;

function readStoredEpoch(): number {
  if (typeof window === 'undefined') {
    return 0;
  }
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return 0;
    }
    const parsed = Number.parseInt(raw, 10);
    return Number.isFinite(parsed) ? parsed : 0;
  } catch {
    return 0;
  }
}

/** Effective epoch (max of in-memory and localStorage). */
export function getSessionEpoch(): number {
  const stored = readStoredEpoch();
  return Math.max(memoryEpoch, stored);
}

/** Invalidate in-flight refresh / broadcast handlers for the previous session. */
export function bumpSessionEpoch(): number {
  const next = getSessionEpoch() + 1;
  memoryEpoch = next;
  if (typeof window !== 'undefined') {
    try {
      localStorage.setItem(STORAGE_KEY, String(next));
    } catch {
      // ignore quota / private mode
    }
  }
  return next;
}

export function isSessionEpochCurrent(epoch: number): boolean {
  return epoch === getSessionEpoch();
}
